import * as React from 'react';
import { connect } from 'react-redux';
import ImageModal from '../General/ImageModal';
import { fetchSeller, editSeller, fetchIntegradores } from '../../actions/sellersActions';
import { putEstadoSellerApi, createImageSellerUrl } from '../../api/axios';
import MiniSpinner from "../General/MiniSpinner";
import Cleave from 'cleave.js/react';
import { toast } from 'react-toastify';

class DatosBasicos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            didEdit: false,
            isUpdatingEstado: false,
            srcImg: "",
            showImg: false
        }
    };

    componentDidMount() {
        this.props.fetchIntegradores();
    }

    componentWillReceiveProps = () => {
        if (this.didEdit) {
            this.props.fetchSeller(this.props.id);
            this.setState({ didEdit: false });
        }
    }

    myChangeHandler = (event) => {
        this.setState({ didEdit: true });
        let seller = this.props.seller;
        seller[event.target.name] = event.target.value;
        this.props.editSeller(seller);
    }

    changeIntegrator = (event) => {
        this.setState({ didEdit: true });
        let seller = { ...this.props.seller };
        seller.integrador = { codigo: event.target.value };
        this.props.editSeller(seller);
    }

    clearImgInput = () => {
        let inputImg = document.getElementById("imgInput");
        inputImg.value = null;
    }

    showImgModal = (e, src) => {
        e.preventDefault();
        this.setState({ showImg: true, srcImg: src });
    }

    hideImgModal = () => {
        this.setState({ showImg: false });
    }

    handleCheckboxEstado = () => {
        this.setState({ isUpdatingEstado: true });
        let seller = { ...this.props.seller };
        seller.estado = seller.estado === "activo" ? "inactivo" : "activo";
        this.props.editSeller(seller);
        this.updateEstadoSeller(seller.estado);
    }

    handleCheckboxTiendaActiva = () => {
        let seller = { ...this.props.seller };
        seller.tiendaActiva = !seller.tiendaActiva;
        this.props.editSeller(seller);
    }

    addImg = async (e) => {
        const image = e.target.files[0];
        let req = createImageSellerUrl(image);
        req.then(res => {
            if (res != "Archivo incorrecto") {
                let seller = { ...this.props.seller, logo: res.url };
                this.props.editSeller(seller);
                this.clearImgInput();
            } else {
                toast.error(res)
            }
        }).catch(error =>
            toast.error("No se pudo cargar la imagen")
        );
    }

    updateEstadoSeller = (estado) => {
        let sellers = putEstadoSellerApi({ idSeller: this.props.seller.codigo, estado: estado });
        sellers.then(res => {
            toast.success("Estado de seller modificado");
        }).catch(err => {
            (err.response.data.errores)
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error("El estado no pudo modificarse");
        }).finally(() => {
            this.setState({ isUpdatingEstado: false });
        });
    };


    render() {
        let integradores = null;
        if (this.props.integradores != undefined) {
            integradores = this.props.integradores.map((item, index) => {
                return (
                    <option key={index} value={item.codigo}>{item.descripcion}</option>
                )
            })
        }

        return (
            <div className="tab-pane p-20 active" name="datos" id="home2" role="tabpanel">
                <div className="row">

                    <div className="form-group col-lg-6">
                        <label>Razón social</label>
                        <input
                            type="text"
                            className="form-control"
                            value={this.props.seller.razonSocial}
                            onChange={this.myChangeHandler}
                            placeholder=""
                            name="razonSocial"
                            maxLength="100"
                        />
                    </div>

                    <div className="form-group col-lg-6">
                        <label>e-Mail contacto comercial</label>
                        <input
                            type="text"
                            className="form-control"
                            value={this.props.seller.email}
                            onChange={this.myChangeHandler}
                            placeholder="usuario@dominio.com"
                            name="email"
                            maxLength="60"
                        />
                    </div>

                    <div className="form-group col-lg-6">
                        <label>Cuit</label>
                        <Cleave
                            className="form-control"
                            name="cuit"
                            value={this.props.seller.cuit}
                            options={{ blocks: [2, 8, 1], delimiter: '-', numericOnly: true }}
                            onChange={this.myChangeHandler}
                        />
                    </div>

                    <div className="form-group col-lg-6">
                        <label>Integrador</label>
                        <select
                            name="integrador"
                            className="form-control"
                            value={this.props.seller.integrador?.codigo ?? 1}
                            onChange={this.changeIntegrator}
                        >
                            {integradores}
                        </select>
                    </div>

                    <div className="form-group col-lg-6">
                        <label>Nombre tienda</label>
                        <input
                            type="text"
                            className="form-control"
                            value={this.props.seller.nombreTienda ?? ""}
                            onChange={this.myChangeHandler}
                            placeholder=""
                            name="nombreTienda"
                            maxLength="50"
                        />
                    </div>

                    <div className="form-group col-md-6">
                        <div className="row">
                            <div className="col-6">
                                <label className="control-label">Estado</label>
                                <div>
                                    <input
                                        type="checkbox"
                                        name="switchEstado"
                                        className="custom-control-input"
                                        onChange={() => this.handleCheckboxEstado()}
                                        checked={this.props.seller.estado === "activo"}
                                        disabled={!this.props.userType.isAdminMod && !this.props.userType.isCategory}
                                    />
                                    <label
                                        htmlFor="switchEstado"
                                        onChange={this.myChangeHandler}
                                        className="custom-control-label mx-1"
                                    >
                                        {this.props.seller.estado === "activo" ? "Activo" : "Inactivo"}
                                    </label>
                                    {this.state.isUpdatingEstado &&
                                        <div className="d-block"><MiniSpinner /></div>
                                    }
                                </div>
                            </div>
                            <div className="col-6">
                                <label className="control-label d-inline">Tienda Activa</label>
                                <div>
                                    <input
                                        type="checkbox"
                                        name="switchTiendaActiva"
                                        className="custom-control-input"
                                        onChange={() => this.handleCheckboxTiendaActiva()}
                                        checked={this.props.seller.tiendaActiva}
                                    />
                                    <label
                                        htmlFor="switchTiendaActiva"
                                        onChange={this.myChangeHandler}
                                        className="custom-control-label mx-1"
                                    >
                                        {this.props.seller.tiendaActiva ? "Activa" : "Inactiva"}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="form-group col-lg-6">

                        <div className="form-group col-lg-6">
                            <label>Logo</label>
                            <div>
                                <input
                                    id="imgInput"
                                    className="m-t-10"
                                    type="file"
                                    name="imagen"
                                    onChange={this.addImg}
                                    accept="image/png, image/jpeg"
                                />
                            </div>
                        </div>

                        <div className="form-group col-lg-4">
                            <img
                                src={this.props.seller.logo}
                                style={{ cursor: 'pointer', width: "50%" }}
                                className="on mw-400px h-100 img-responsive"
                                onClick={e => this.showImgModal(e, this.props.seller.logo)}
                            />
                        </div>

                        <ImageModal
                            src={this.state.srcImg}
                            show={this.state.showImg}
                            onHide={this.hideImgModal}
                        />

                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    userType: state.general.userType,
    integradores: state.sellers.integradores,
    seller: JSON.stringify(state.general.generalObject) != "{}"
        ? state.general.generalObject
        : state.sellers.seller
    ,
});

export default connect(mapStateToProps, {
    fetchIntegradores,
    fetchSeller,
    editSeller
})(DatosBasicos);